<template>
  <header class="heading-with-description">
    <Heading
      :text="textHeading"
      :size="sizeHeading"
    />
    <p
      class="heading-with-description__description"
      v-text="textDescription"
    />
  </header>
</template>

<script>
import { Heading } from '@/components/base';

export default {
  name: 'HeadingWithDescription',
  components: {
    Heading,
  },
  props: {
    textHeading: {
      type: String,
      required: true,
    },
    sizeHeading: {
      type: Number,
      default: 24,
    },
    textDescription: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.heading-with-description {
  margin-bottom: var(--ds-spacing-stack-md);

  &__description {
    margin-top: var(--ds-spacing-stack-nano);
    margin-bottom: 0;
    font-size: var(--ds-font-size-sm);
  }
}
</style>
